import { render, staticRenderFns } from "./CursosApp.vue?vue&type=template&id=f739e2dc&scoped=true"
import script from "./CursosApp.vue?vue&type=script&lang=js"
export * from "./CursosApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f739e2dc",
  null
  
)

export default component.exports